import type { ISupportedLanguagesAndLocale } from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import type { IRTCurrentCampaignData } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";

import { useConfigurationState } from "./useConfigurationState";
import { useFixedGscConfig } from "./useFixedGscConfig";
import { useKeywordsState } from "./useKeywordsState";
import { useTagsState } from "./useTagsState";

export const useAddKeywordsModal = (
    campaignConfig: IRTCurrentCampaignData,
    languagesList: ISupportedLanguagesAndLocale[],
) => {
    const configuration = useConfigurationState(campaignConfig, languagesList);
    const keywords = useKeywordsState("seo.keywordsCampaign.wizard.addingKeywordsStep.gscKeywords.sourceName");
    const tags = useTagsState(campaignConfig);
    const fixedGscConfig = useFixedGscConfig(
        campaignConfig,
        configuration.selectedDevice,
        configuration.selectedLocationIds,
        languagesList,
    );

    return { configuration, keywords, tags, fixedGscConfig };
};
